<template>
    <app-layout title="Nastavení">

        <settings-tabs-navigation/>

        <div>
            <div class="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">
                <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                    <update-profile-information-form :user="$page.props.user" />
                </div>

                <div v-if="$page.props.jetstream.canUpdatePassword">
                    <jet-section-border />
                    <update-password-form class="mt-10 sm:mt-0" />
                </div>

                <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                    <jet-section-border />
                    <two-factor-authentication-form class="mt-10 sm:mt-0" />
                </div>

                <div>
                    <jet-section-border />
                    <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />
                </div>
                <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                    <jet-section-border />
                    <delete-user-form class="mt-10 sm:mt-0" />
                </template>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import DeleteUserForm from './DeleteUserForm';
    import JetSectionBorder from '@/Jetstream/SectionBorder';
    import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm';
    import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm';
    import UpdatePasswordForm from './UpdatePasswordForm';
    import UpdateProfileInformationForm from './UpdateProfileInformationForm';
    import SettingsTabsNavigation from "../Settings/SettingsTabsNavigation";

    export default {
        props: ['sessions'],

        components: {
            SettingsTabsNavigation,
            AppLayout,
            DeleteUserForm,
            JetSectionBorder,
            LogoutOtherBrowserSessionsForm,
            TwoFactorAuthenticationForm,
            UpdatePasswordForm,
            UpdateProfileInformationForm,
        },
    }
</script>
